import distanceBetweenPoints from "./distance-utils"

interface Departments {
  Id: string
  Name: string
  IconSuffix: string
}

export interface Dealership {
  AddressLine1: string
  AddressLine2: string
  County: string
  Departments: Departments[]
  DisplayAddress: string
  Latitude: number
  Longitude: number
  Name: string
  Postcode: string
  Town: string
  Url: string
  DealershipId: string;
  GlobalDealershipId: string;
}

interface DealershipData {
  Distance?: string
  Name: string
  Value: string
  GlobalDealershipId?: string
  Url?: string
}

interface Location {
  latitude: number
  longitude: number
}

type MappedDealerships = DealershipData[]
type StringOrNull = string | null
type StringOrNumber = string | number

export const CHARLESHURST_DEALERSHIP_NAME = "Hurst Car Buyer Belfast"
// For local dev purpose
// export const CHARLESHURST_DEALERSHIP_NAME = "Hurst Car Buyer"
export const CHARLESHURST_GROUP_ID = "403776a9-934b-46e3-9724-2bc86bab3060"

export function findByProperty(
  dealerships: Dealership[],
  property: string,
  matchingValue: StringOrNumber
) {
  const predicate = (d: Dealership) =>
    d[property as keyof Dealership] === matchingValue
  return dealerships.find(predicate)
}

export function mapDealerships(
  dealerships: Dealership[],
  location: Location
): MappedDealerships {
  return dealerships.map((dealership: Dealership, i): DealershipData => {
    let Distance

    Distance = distanceBetweenPoints({
        start: location,
        end: {
          latitude: dealership.Latitude,
          longitude: dealership.Longitude,
        },
      })

    return {
      Name: dealership.Name,
      Distance,
      Value: dealership.Name,
			GlobalDealershipId: dealership.GlobalDealershipId?.toLocaleLowerCase(),
      Url: dealership.Url,
    }
  })
}

export function getHurstDealership(
  dealerships: Dealership[],
  location: Location
): MappedDealerships | [] {
  const charleshurstDealership = findByProperty(
    dealerships,
    "Name",
    CHARLESHURST_DEALERSHIP_NAME
  )

  if (charleshurstDealership) {
    return mapDealerships([charleshurstDealership], location)
  }
  return []
}

export function getDealershipData(
  dealerships: Dealership[],
  groupId: string,
  location: Location
): MappedDealerships {
  if (groupId === CHARLESHURST_GROUP_ID) {
    return getHurstDealership(dealerships, location)
  }
  return mapDealerships(dealerships, location)
}

export function findMatchingDealershipByName(
  dealerships: Dealership[],
  dealershipName: string
): Dealership | undefined {
  const predicate = (d: Dealership) => {
    const {
      Name: name
    } = d

    const re = new RegExp(`${name}`, "i")
    return re.test(dealershipName)
  }
  return dealerships.find(predicate)
}

export function getGlobalDealershipId(
  dealerships: Dealership[],
  dealershipName: string
): StringOrNull {
  const matchingDealership = findMatchingDealershipByName(
    dealerships,
    dealershipName
  )
  return matchingDealership?.GlobalDealershipId?.toLocaleLowerCase() ?? null
}

export function getDealershipUrl(
  dealerships: Dealership[],
  dealershipName: string
): StringOrNull {
  const matchingDealership = findMatchingDealershipByName(
    dealerships,
    dealershipName
  )
  return (
    matchingDealership?.Url ?? null
  )
}

export function filterDealerships(dealershipList: Dealership[], groupId: string) {
  if (groupId !== CHARLESHURST_GROUP_ID) {
    return dealershipList.filter((dealer: Dealership) => !dealer.Url.includes("charleshurst") && dealer)
  } else {
    return dealershipList
  }
}